import React from 'react';

import { requirementShape } from '../../../prop-types';

export default function SizeThumbnail({ requirement }) {
  const {
    requirements: { imageWidth, imageHeight },
  } = requirement;
  const maxSize = 100;
  let width = maxSize;
  let height = maxSize;
  if (imageWidth > imageHeight) {
    height = imageHeight * (maxSize / imageWidth);
  } else {
    width = imageWidth * (maxSize / imageHeight);
  }
  return (
    <div
      className="bg-secondary d-inline-flex align-items-center justify-content-center text-light"
      style={{ width, height }}
    >
      {imageWidth} x {imageHeight}
    </div>
  );
}

SizeThumbnail.propTypes = {
  requirement: requirementShape.isRequired,
};
